export default "__VITE_ASSET__0253982d__"